import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AvField from "../../shared/component/form/AvField";

const defaultCity = {
    id: '',
    name:''
    
};
export default class CitySave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            city: defaultCity,
            pageMode: null
        };
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="name">İl Adı<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="name"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 20,
                                    errorMessage: 'Bu alan en fazla 20 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.city.name}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let city = this.state.city;
        city[e.target.name] = value;
        this.setState({city: city});
    }

    setData = (data, pageMode) => {
        this.setState({city: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.city;
    }

    clearData = () => {
        this.setState({city: Object.assign({}, defaultCity), pageMode: null});
    }

}
